import { Button } from '@journ/ui/button'
import { Icons } from '@journ/ui/icons'
import { Sheet, SheetContent, SheetHeader } from '@journ/ui/sheet'
import { useIntlayer } from 'react-intlayer'
import { GLOBAL_SHEET_IDS, useSheet } from '@/features/ui/hooks/use-sheet'
import { customers, notify } from '../wiring'
import { upsertCustomer } from '../application/upsert-customer'
import { refreshCustomerList } from '../store'
import { CustomerForm } from './customer-form'
import type { SubmitValues } from './customer-form'

const CustomerCreateSheet = () => {
	const content = useIntlayer('customers-page')
	const { isOpen, close } = useSheet(GLOBAL_SHEET_IDS.CUSTOMER_CREATE)

	const handleSubmit = async (values: SubmitValues): Promise<void> => {
		await upsertCustomer(
			customers,
			{
				kind: values.kind,
				name: values.name,
				email: values.email,
				taxId: values.taxId ?? null,
				phone: values.phone ?? null,
				website: values.website ?? null,
				contact: values.contact ?? null,
				logo: values.logo,
				addressLine1: values.addressLine1 ?? null,
				addressLine2: values.addressLine2 ?? null,
				city: values.city ?? null,
				state: values.state ?? null,
				country: values.country ?? null,
				countryCode: values.countryCode ?? null,
				zip: values.zip ?? null,
				note: values.note ?? null,
			},
			notify,
		)
		refreshCustomerList()
		close()
	}

	return (
		<Sheet open={isOpen} onOpenChange={close}>
			<SheetContent stack title={content.createSheet.title.value} className='flex flex-col'>
				<SheetHeader className='mb-6 flex justify-between items-center flex-row shrink-0'>
					<h2 className='text-xl'>{content.createSheet.title}</h2>
					<Button size='icon' variant='ghost' onClick={close} className='p-0 m-0 size-auto hover:bg-transparent'>
						<Icons.Close className='size-5' />
					</Button>
				</SheetHeader>
				<CustomerForm onSubmit={handleSubmit} onCancel={close} />
			</SheetContent>
		</Sheet>
	)
}

export { CustomerCreateSheet }
